/* eslint-disable */
class CommonClass {
  constructor() {
    this.api_url = "https://api.aspiricx.com";
    this.cdn_url = "https://cdn.aspiricx.com/";
    // this.cdn_url = "http://localhost:1312/";
    this.componentPage;
  }
}

export default new CommonClass();



// WEBPACK FOOTER //
// src/js/common.js